<template>
  <div id="chat-session">
    <div class="container">

      <h1>Welcome to the Casey Assistant</h1>

      <p><strong>Your AI-powered solution for managing cases and analyzing data with ease.</strong></p>

      <ChatInput></ChatInput> 


    </div>
  </div>
</template>

<script>
import ChatInput from '@/components/chat/ChatInput'

export default {
  name: "ChatSession",
  components: {
    ChatInput
  },
  async mounted() {
    await this.$store.dispatch("clearCurrentChatSession")
  }
}
</script>


<style lang="scss" scoped>
#chat-session {
  height: 100%;
  width: 100%;

  .container {
    max-height: 80%;
    max-width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
